import { Link } from "react-router-dom";

// items: [{ label, to }] — last item is the current page (no link)
export const Breadcrumbs = ({ items = [] }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="edge pt-28 md:pt-36">
    <ol className="flex flex-wrap items-center gap-2 text-[0.7rem] uppercase tracking-[0.16em] text-muted-foreground">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <li key={it.to || it.label} className="flex items-center gap-2">
            {last || !it.to ? (
              <span className={last ? "text-foreground" : ""} data-testid={`breadcrumb-${i}`}>
                {it.label}
              </span>
            ) : (
              <Link
                to={it.to}
                data-testid={`breadcrumb-${i}`}
                className="transition-colors hover:text-foreground"
              >
                {it.label}
              </Link>
            )}
            {!last && <span className="text-muted-foreground/50">/</span>}
          </li>
        );
      })}
    </ol>
  </nav>
);
